import { connect } from 'react-redux';
import Application from './Application';
import {
  isFetching,
  getError,
  getCurrentPage,
  hasApplications,
} from '../../../state/reducers/ApplicationReducer';
import ApplicationActions from '../../../state/actions/ApplicationActions';
import ConfigActions from '../../../state/actions/ConfigActions';
import {
  isLoaded,
  isFetching as isFetchingConfigs,
} from '../../../state/reducers/ConfigReducer';
import { isLAO } from '../../../state/reducers/LoginReducer';

const mapStateToProps = (state) => ({
  isLAO: isLAO(state),
  isFetching: isFetching(state) || isFetchingConfigs(state),
  isLoaded: isLoaded(state),
  error: getError(state),
  currentPage: getCurrentPage(state),
  hasApplications: hasApplications(state),
});

const { validateRequest, goToPreviousPage } = ApplicationActions;
const { getConfigRequest } = ConfigActions;

export default connect(mapStateToProps, {
  save: validateRequest,
  loadData: getConfigRequest,
  goBack: goToPreviousPage,
})(Application);



// WEBPACK FOOTER //
// ./src/view/scenes/Application/index.js